import { useTranslation } from 'common/utilities/i18n'
import { CollapseWrapper } from './dev-tools'

export function Languages() {
  const stuff = useTranslation()
  const { i18n } = stuff
  const { options, language: currentLanguage } = i18n

  const languages = options?.allLanguages

  // Set state for component
  const [language, setLanguage] = React.useState(currentLanguage)

  const handleChange = async (event) => {
    const selectedValue = event.currentTarget.value
    try {
      await i18n.changeLanguage(selectedValue)
      setLanguage(selectedValue)
    } catch (err) {
      console.warn(err)
    }
  }

  return languages.length ? (
    <CollapseWrapper title="Languages" collapsed>
      <select onChange={handleChange} value={language}>
        {languages.map((languageOption) => (
          <option key={languageOption} value={languageOption}>
            {languageOption}
          </option>
        ))}
      </select>
    </CollapseWrapper>
  ) : null
}
